var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RatioBox',_vm._b({},'RatioBox',_vm.$attrs,false),[_c('video',_vm._b({attrs:{"src":_vm.src,"width":_vm.videoAttrs.width || '100%',"height":_vm.videoAttrs.height || '100%'}},'video',_vm.videoAttrs,false))])}
var staticRenderFns = []

export { render, staticRenderFns }